import { render, staticRenderFns } from "./ListaTicketsAparcados.vue?vue&type=template&id=d1636238&"
import script from "./ListaTicketsAparcados.vue?vue&type=script&lang=js&"
export * from "./ListaTicketsAparcados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports